<script>
  import Select from './Select.vue';
  import { mask } from 'vue-the-mask';

  export default {
    directives: {
      mask,
    },

    components: {
      Select,
    },

    props: {
      label: {
        type: String,
        required: false,
        default: 'Informações do cartão',
      },

      name: {
        type: String,
        required: false,
        default: '',
      },

      code: {
        type: [
          String, Number,
        ],
        required: false,
        default: '',
      },

      number: {
        type: [
          String, Number,
        ],
        required: false,
        default: '',
      },

      validity: {
        type: [
          String, Number,
        ],
        required: false,
        default: '',
      },

      installment: {
        type: [
          String, Number,
        ],
        required: false,
        default: 1,
      },

      installments: {
        type: Object,
        required: false,
        default: null,
      },

      price: {
        type: Number,
        required: false,
        default: null,
      },

      cardError: {
        type: String,
        required: false,
        default: null,
      },

      error: {
        type: String,
        required: false,
        default: null,
      }
    },
  };
</script>

<template>
  <fieldset
    class="bdk-checkout-card"
  >
    <label
      v-text="__(label)"
      class="bdk-block bdk-text-sm bdk-font-medium bdk-text-gray-700 bdk-text-left"
    />

    <div
      class="bdk-mt-1 bdk-bg-white bdk-rounded-md bdk-shadow-sm bdk--space-y-px"
    >
      <input
        type="text"
        :value="number"
        id="card-number"
        name="card-number"
        v-mask="'#### #### #### ####'"
        placeholder="1234 1234 1234 1234"
        @input="$emit('update:number', $event.target.value)"
        class="focus:bdk-ring-indigo-500 focus:bdk-border-indigo-500 bdk-relative bdk-block bdk-w-full bdk-rounded-none bdk-rounded-t-md bdk-bg-transparent focus:bdk-z-10 sm:bdk-text-sm bdk-border-gray-300 form-input"
      />

      <div
        class="bdk-flex bdk--space-x-px"
      >
        <div
          class="bdk-w-1/2 bdk-flex-1 bdk-min-w-0"
        >
          <input
            type="text"
            :value="validity"
            v-mask="'## / ##'"
            placeholder="MM / AA"
            id="card-expiration-date"
            name="card-expiration-date"
            @input="$emit('update:validity', $event.target.value)"
            class="focus:bdk-ring-indigo-500 focus:bdk-border-indigo-500 bdk-relative bdk-block bdk-w-full bdk-rounded-none bdk-rounded-bl-md bdk-bg-transparent focus:bdk-z-10 sm:bdk-text-sm bdk-border-gray-300 form-input"
          />
        </div>

        <div
          class="bdk-flex-1 bdk-min-w-0"
        >
          <input
            type="text"
            id="card-cvc"
            :value="code"
            v-mask="'###'"
            name="card-cvc"
            placeholder="CVC"
            @input="$emit('update:code', $event.target.value)"
            class="focus:bdk-ring-indigo-500 focus:bdk-border-indigo-500 bdk-relative bdk-block bdk-w-full bdk-rounded-none bdk-rounded-br-md bdk-bg-transparent focus:bdk-z-10 sm:bdk-text-sm bdk-border-gray-300 form-input"
          />
        </div>
      </div>

      <span
        v-if="cardError"
        v-text="cardError"
        class="bdk-mt-2 bdk-text-sm bdk-text-red-600"
      />
    </div>

    <div
      class="bdk-mt-4"
    >
      <label
        v-text="__('Nome no cartão')"
        class="bdk-block bdk-text-sm bdk-font-medium bdk-text-gray-700 bdk-text-left"
      />

      <div
        class="bdk-mt-1"
      >
        <input
          type="text"
          :value="name"
          id="card-name"
          name="card-name"
          @input="$emit('update:name', $event.target.value)"
          class="bdk-shadow-sm focus:bdk-ring-indigo-500 focus:bdk-border-indigo-500 bdk-block bdk-w-full sm:bdk-text-sm bdk-border-gray-300 bdk-rounded-md form-input"
        >
      </div>

      <span
        v-if="error"
        v-text="error"
        class="bdk-mt-2 bdk-text-sm bdk-text-red-600"
      />
    </div>

    <Select
      v-if="price"
      :price="price"
      class="bdk-mt-4"
      :value="installment"
      :installments="installments"
      @input="$emit('update:installment', $event)"
    />
  </fieldset>
</template>
